var _g, _g2, _g3, _g4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIpteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 399.36,
    height: 189.283,
    viewBox: "0 0 399.36 189.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3699",
    "data-name": "Gruppe 3699",
    transform: "translate(242.359 28.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M401.65,421.014l6.365-21.244H332.449L311,468.423h75.556l6.877-21.594H363.115l.936-2.9h22.224l6.08-20.284H370.345l.939-2.607,30.366-.019Zm-19.739,10.2-1.675,5.268H358.1l-5.6,17.96h30.437l-2.1,6.359H321.482L338.4,407.275h59.345l-2.095,6.25H365.333l-5.548,17.694Z",
    transform: "translate(-311 -399.77)",
    fill: "#f0f0f0",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3700",
    "data-name": "Gruppe 3700",
    transform: "translate(164.09 28.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M294.223,399.744,286.748,423.1H304.4l-14.388,45.467H334.8L349.055,423.1h21.278l7.484-23.241-83.6-.112Zm70.257,14.808H343.217l-14.51,46.225h-27.7l14.5-46.228-17.547,0,2.346-7.3v.016l66.632-.016-2.459,7.3Z",
    transform: "translate(-286.748 -399.744)",
    fill: "#f0f0f0",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3701",
    "data-name": "Gruppe 3701",
    transform: "translate(57.434 28.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M275.2,399.774,253.7,468.4l40.568,0,7.426-24.611h42.85L358.8,399.89l-83.6-.116Zm63.566,36.514h-42.5l-7.142,24.522H263.7l17.586-53.531v.019l66.635-.019-9.153,29.009Z",
    transform: "translate(-253.701 -399.774)",
    fill: "#f0f0f0",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3702",
    "data-name": "Gruppe 3702",
    transform: "translate(100.892 41.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M272.68,403.833l-5.514,17.848h17.617l5.512-17.848Z",
    transform: "translate(-267.167 -403.833)",
    fill: "#f0f0f0",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4875",
    "data-name": "Pfad 4875",
    d: "M237.508,468.423l21.5-68.653h42.672l-21.572,68.653Zm10.573-7.617h26.206L291.2,407.275H264.841l-16.76,53.531Z",
    transform: "translate(-232.335 -371.455)",
    fill: "#f0f0f0",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4876",
    "data-name": "Pfad 4876",
    d: "M509.968,496.8l20.946,14.119,23.238-13.624,10.054,50.37,49.076-156.712-7.8,112.195,14.646-14.589,15.138,12.116-1.677,8.527L620.8,498.714,595.937,523.6l4.614-64.282L562.8,580.232l-13.855-71.057L530.4,520.063l-22.857-15.536H235.9l2.422-7.727,271.641,0Z",
    transform: "translate(-235.905 -390.949)",
    fill: "#d73239",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpteLogo);
export default __webpack_public_path__ + "static/media/ipte-logo.156d85c902deaa85cb18ee9b4e6c94e4.svg";
export { ForwardRef as ReactComponent };